import { deconstructNumberFormat } from './deconstruct-number-format';
import formatFactory, { INumberFormat } from './format-number';

export default function formatNumberWithString(value, requiredFormat, overrideOptions?: INumberFormat) {
  let deconstructedFormat: INumberFormat | undefined;

  if (requiredFormat) {
    deconstructedFormat = deconstructNumberFormat(requiredFormat.trim());
  }

  value = (value === null ? '' : value);
  value = value + ''; // make a string
  value = value.length ? value.trim() : '';

  let format;

  if (deconstructedFormat) {
    format = formatFactory({
      negativeType: deconstructedFormat.negativeType,
      negativeLeftSymbol: deconstructedFormat.negativeLeftSymbol,
      negativeRightSymbol: deconstructedFormat.negativeRightSymbol,
      negativeLeftOut: deconstructedFormat.negativeLeftPos === 0,
      negativeRightOut: deconstructedFormat.negativeRightPos === 0,
      prefix: deconstructedFormat.prefix,
      suffix: deconstructedFormat.suffix,
      integerSeparator: deconstructedFormat.integerSeparator,
      decimalsSeparator: deconstructedFormat.decimalsSeparator,
      decimal: deconstructedFormat.decimalChar,
      padLeft: deconstructedFormat.padLeft,
      padRight: deconstructedFormat.padRight,
      round: deconstructedFormat.maxRight,
      truncate: undefined
    });
  }
  else {
    format = formatFactory({
      negativeLeftOut: false,
      negativeRightOut: false,
      truncate: undefined
    });
  }

  return format(value, overrideOptions);
}
